/**
 * Farbband der Liegezeit – eine Stelle für alle Ansichten.
 *
 * „Meine Aufgaben" und das Vertriebscockpit zeigen dieselbe Zahl und müssen
 * sie gleich einfärben. Zwei Umsetzungen liefen auseinander: Das Cockpit hatte
 * eigene Schwellen im Code und ein Oliv-Braun, während „Meine Aufgaben" die
 * zentral gepflegten Bänder und Bernstein verwendete. Derselbe Vorgang sah in
 * zwei Masken unterschiedlich dringend aus.
 *
 * Es sind Farben, keine Fristen: Sie sagen, wie lange etwas liegt – nicht,
 * dass jemand etwas versäumt hätte.
 */
export type Liegestufe = 'gruen' | 'bernstein' | 'rot';

export function liegestufe(tage: number, gruenBis: number, orangeBis: number): Liegestufe {
  if (tage > orangeBis) return 'rot';
  if (tage > gruenBis) return 'bernstein';
  return 'gruen';
}